import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin , useGoogleLogin} from '@react-oauth/google';
import { ArrowLeft, ArrowRight, ShieldCheck } from 'lucide-react';
import Page from './Page'; // ייבוא רכיב המעטפת הכללי


import {utils} from './utils/index'

const REACT_APP_API_HOST = utils.config.REACT_APP_API_HOST;

export default function AuthPage() {
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(false);
  const [authStatus, setAuthStatus] = useState('idle'); // idle, loading, error
  const [errorMessage, setErrorMessage] = useState('');


  
  const loginWithGoogle = useGoogleLogin({
    // 1. הגדרת הטווחים הנדרשים: פרופיל, אימייל וגישה לניהול קבצי האפליקציה בדרייב
    scope: 'openid profile email https://www.googleapis.com/auth/drive.file',
    
    // 2. שינוי ה-Flow ל-auth-code מאפשר לשרת לקבל גם Refresh Token לעבודת רקע
    flow: 'auth-code', 
    
    onSuccess: async (codeResponse) => {
      // כעת codeResponse מכיל שדה בשם code במקום access_token
      setAuthStatus('loading');
      setErrorMessage('');

      const endpoint = '/api/auth/google/callback-post';
      const serverUrl = getServerUrl();

      try {
        const response = await fetch(`${serverUrl}${endpoint}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          // שליחת ה-code לשרת. השרת ישתמש ב-oauth2Client.getToken(code) כפי שכתבנו בראוטר
          body: JSON.stringify({ code: codeResponse.code }), 
        });

        if (!response.ok) throw new Error('Server authentication check failed');

        const data = await response.json();
        if (data.token) localStorage.setItem('token', data.token);

        if (data.user) {
          localStorage.setItem('user', JSON.stringify(data.user));
        }

        navigate('/agent');
      } catch (error) {
        console.error('Auth Backend Error:', error);
        setAuthStatus('error');
        setErrorMessage(`התקשרות עם השרת נכשלה (${serverUrl}${endpoint})`);
      }
    },
    onError: () => {
      console.error('Google Auth Failed');
      setAuthStatus('error');
      setErrorMessage('ההתחברות באמצעות גוגל נכשלה. נסה שנית.');
    }
  });

  const getServerUrl = () => {
    const url = REACT_APP_API_HOST;
    console.log("REACT_APP_API_HOST" , url);
    if (url){
      return url.replace(/\/+$/, '');
    } else {
        return 'https://aiapi.agentruntime.cloud'
    }
    
  };

//   const handleLoginSuccess = async (credentialResponse) => {
//   console.log('Google Auth Success:', credentialResponse);
//   setAuthStatus('loading');
//   setErrorMessage('');

//   // Using our unified backend endpoint instead of separating login/register
//   const endpoint = '/api/auth/google';
//   const serverUrl = getServerUrl();

//   try {
//     const response = await fetch(`${serverUrl}${endpoint}`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ token: credentialResponse.credential }),
//     });

//     if (!response.ok) {
//       throw new Error('Server authentication check failed');
//     }

//     const data = await response.json();
    
//     // Storing our real localAppToken securely in localStorage
//     if (data.token) {
//       localStorage.setItem('token', data.token);
//     }

//     navigate('/agent');
//   } catch (error) {
//     console.error('Auth Backend Error:', error);
//     setAuthStatus('error');
//     setErrorMessage(`התקשרות עם השרת נכשלה (${serverUrl}${endpoint})`);
//   }
// };

//   const handleLoginError = () => {
//     console.error('Google Auth Failed');
//     setAuthStatus('error');
//     setErrorMessage('ההתחברות באמצעות גוגל נכשלה. נסה שנית.');
//   };

  return (
    <Page totalFilesCount={0}>
     

      {/* תוכן הטופס הראשי */}
      <div className="max-w-md w-full mx-auto py-6 flex flex-col justify-center">
        
        {/* כותרת דינמית */}
        <div className="text-center mb-8 space-y-2">
          <h2 className="text-2xl font-bold text-slate-950 tracking-tight">
            {isSignUp ? 'הרשמה למערכת' : 'התחברות לחשבון'}
          </h2>
          <p className="text-sm text-slate-400 max-w-xs mx-auto leading-relaxed">
            {isSignUp 
              ? '.ההרשמה  באמצעות גוגל.' 
              : 'טוב לראות אותך שוב!'}
          </p>
        </div>

        {/* אזור הפעולה הראשי */}


         <div className="space-y-6">
        <div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm space-y-5">
          
          {authStatus === 'error' && (
            <div className="p-3.5 rounded-xl bg-rose-50 border border-rose-100 text-rose-700 text-xs text-center font-medium">
              {errorMessage}
            </div>
          )}

          {/* 3. כאן אתה יכול לעצב כפתור Tailwind מותאם אישית לחלוטין! */}
          <button
            onClick={() => loginWithGoogle()} // הפעלת חלון גוגל בלחיצה
            disabled={authStatus === 'loading'}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-slate-200 rounded-xl font-medium text-sm text-slate-700 bg-white hover:bg-slate-50 active:scale-[0.98] transition-all duration-150 disabled:opacity-50 disabled:pointer-events-none"
          >
            {/* אייקון גוגל נקי */}
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#EA4335" d="M12 5.04c1.62 0 3.08.56 4.22 1.65l3.15-3.15C17.45 1.68 14.96 1 12 1 7.35 1 3.37 3.67 1.39 7.56l3.77 2.93c.9-2.69 3.42-4.45 6.84-4.45z"/>
              <path fill="#4285F4" d="M23.49 12.27c0-.81-.07-1.59-.2-2.34H12v4.44h6.44c-.28 1.48-1.11 2.73-2.37 3.58l3.7 2.87c2.16-1.99 3.42-4.92 3.42-8.55z"/>
              <path fill="#FBBC05" d="M5.16 14.63c-.23-.69-.36-1.43-.36-2.2s.13-1.51.36-2.2L1.39 7.56C.5 9.34 0 11.32 0 13.42s.5 4.08 1.39 5.86l3.77-2.93z"/>
              <path fill="#34A853" d="M12 23c3.24 0 5.97-1.07 7.96-2.93l-3.7-2.87c-1.03.69-2.34 1.1-4.26 1.1-3.42 0-5.94-1.76-6.84-4.45L1.39 16.78C3.37 20.67 7.35 23 12 23z"/>
            </svg>
            <span>{isSignUp ? 'הרשמה באמצעות Google' : 'התחברות באמצעות Google'}</span>
          </button>

          <p className="text-[11px] text-center text-slate-400 px-2 leading-relaxed">
            בלחיצה על הכפתור, הנך מסכים ל
            <a href="#" className="underline hover:text-indigo-600 transition-colors mx-1">תנאי השימוש</a> 
            ול
            <a href="#" className="underline hover:text-indigo-600 transition-colors mx-1">מדיניות הפרטיות</a>.
          </p>
        </div>

         <div className="text-center">
            <button
              onClick={() => {
                setIsSignUp(!isSignUp);
                setAuthStatus('idle');
                setErrorMessage('');
              }}
              className="inline-flex items-center gap-2 text-xs font-semibold text-indigo-600 hover:text-indigo-700 transition-colors duration-150 focus:outline-none"
            >
              <span>{isSignUp ? 'כבר יש לך חשבון? התחבר' : 'אין לך חשבון עדיין? הירשם עכשיו'}</span>
              <ArrowLeft className="w-3.5 h-3.5 transform " />
            </button>
          </div>

       
        </div>

     
      </div>
    </Page>
    
  );
}